import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";
import type { SetupStepRowState } from "Components/Dashboard/SetupChecklist/types";
import type { ReactNode } from "react";

// Every variant keeps the same bounding box so row titles align; the drawn
// circles match the visible circle of the AccessTime glyph, which carries
// built-in padding inside its icon box.
const INDICATOR_SIZE = 22;
const CIRCLE_SIZE = 20;

type Props = {
  state: SetupStepRowState;
  stepNumber: number;
};

export const SetupStepIndicator = ({ state, stepNumber }: Props) => {
  if (state === "inReview") {
    return (
      <AccessTimeIcon
        sx={{
          fontSize: INDICATOR_SIZE,
          color: "text.disabled",
          flexShrink: 0,
        }}
      />
    );
  }

  if (state === "done") {
    return (
      <Layout>
        <Box
          width={CIRCLE_SIZE}
          height={CIRCLE_SIZE}
          borderRadius="50%"
          bgcolor="primary.main"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CheckIcon sx={{ fontSize: 13, color: "primary.contrastText" }} />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box
        width={CIRCLE_SIZE}
        height={CIRCLE_SIZE}
        borderRadius="50%"
        border="1px solid"
        borderColor="divider"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" fontWeight={600} color="text.secondary">
          {stepNumber}
        </Typography>
      </Box>
    </Layout>
  );
};

const Layout = ({ children }: { children: ReactNode }) => (
  <Box
    width={INDICATOR_SIZE}
    height={INDICATOR_SIZE}
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
  >
    {children}
  </Box>
);
